<script>
export default {
  functional: true,
  props: {
    icon: { type: String, required: true },
    heading: { type: String, required: true },
    subheading: { type: String, default: null }
  },

  render(h, { props }) {
    return (
      <div class="d-flex align-items-center w-100 px-1">
        <v-icon
          icon={props.icon}
          color="var(--brand-color-hex)"
          class="mr-2"
          size="2rem"
        />
        <div>
          <h4 class="my-0">{props.heading}</h4>
          {props.subheading && (
            <small class="my-0 text-grey-60">{props.subheading} </small>
          )}
        </div>
      </div>
    )
  }
}
</script>
